import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../api/hooks/useAPI";
import { NotificationContext } from "../../../contexts/NotificationContext";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { ONBOARDING_STEPS } from "../../../utils/constants";
import ContainedButton from "../../buttons/ContainedButton";
import TextButton from "../../buttons/TextButton";
import { Toast } from "../../Toast";

const ScanStep = () => {
  const navigate = useNavigate();
  const { setOnboardingStage } = useOnboarding();
  const { trackEvent, requestFullScan } = useAPI();
  const { isScanning, setIsScanning, setTaskId } =
    useContext(NotificationContext);

  const handleStartScan = async () => {
    trackEvent("User started scan");
    if (isScanning) {
      setOnboardingStage(ONBOARDING_STEPS.SCAN_PROGRESS);
      Toast.info("Scan already in progress");
      return;
    }
    try {
      // Fix
      setOnboardingStage(ONBOARDING_STEPS.SCAN_PROGRESS);
      await requestFullScan().then((result) => {
        setIsScanning(true);
        Toast.info("Scan started");
        setTaskId(result.data);
      });
    } catch (error) {
      console.error("Failed to start scan:", error);
    }
  };

  const handleConnectMoreTools = () => {
    trackEvent("User chose to connect more tools");
    navigate("/inventory/integrations");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: 2,
        p: 3,
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        Step 2 of 4
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", mr: 1 }}>
          Scan Your Environment
        </Typography>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            role="img"
            aria-label="magnifying glass"
            style={{ fontSize: "24px" }}
          >
            🔍
          </span>
        </Box>
      </Box>

      <Typography variant="body1">
        We'll perform a scan based on your connected tool to uncover critical
        gaps, misconfigurations, and exposures in your environment.
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        This may take up to <strong>30 minutes</strong> — we'll notify you when
        it's ready to review.
      </Typography>

      <Typography variant="body1">
        Starting the scan is the <strong>fastest way to get insights</strong> —
        and you'll be able to invite teammates while it runs. If you already
        want broader visibility, you can connect more tools now.
      </Typography>

      <Box
        sx={{ display: "flex", justifyContent: "center", gap: 2, mt: "40px" }}
      >
        <ContainedButton
          color="primary"
          size="large"
          onClick={handleConnectMoreTools}
        >
          Connect More Tools
        </ContainedButton>
        <TextButton color="primary" size="large" onClick={handleStartScan}>
          Start Scan
        </TextButton>
      </Box>
    </Box>
  );
};

export default ScanStep;
